"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[23540],{

/***/ 391122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(203494);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4247);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(320589);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const optionHeight = 2.5;
const Item = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  return `
    height: ${optionHeight}rem;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    position: relative;
    align-items: center;
    background: ${(_a = props.theme) == null ? void 0 : _a.colors.white};
    padding-left: ${(_b = props.theme) == null ? void 0 : _b.spacing.s16};
    padding-right: ${(_c = props.theme) == null ? void 0 : _c.spacing.s16};
    border-radius: ${(_d = props.theme) == null ? void 0 : _d.borderRadius.s};
    cursor: pointer;
    &:hover {
      background: ${(_e = props.theme) == null ? void 0 : _e.colors.background};
    }
    ${props.hasDivider ? ` &:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         right: ${(_f = props.theme) == null ? void 0 : _f.spacing.s16};
         bottom: 0;
         left: ${(_g = props.theme) == null ? void 0 : _g.spacing.s16};
         border-bottom: ${(_h = props.theme) == null ? void 0 : _h.borderWeight.m} solid ${(_i = props.theme) == null ? void 0 : _i.colors.divider};
         -webkit-transform: scaleY(0.5);
         transform: scaleY(0.5);
       }` : ``}
`;
});
const LeftContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  flex: 1;
  text-align: left;
`;
const RightContent = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  width: 1.5rem;
  text-align: right;
`;
const ItemsWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme, maxPerView }) => `
    background: ${theme == null ? void 0 : theme.colors.white};
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.05);
    border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    ::-webkit-scrollbar {
      display: none;
    }
    position: absolute;
    top: 2.75rem;
    width: 100%;
    padding: 0.25rem;
    z-index: 1000;
    ${maxPerView ? `height: ${maxPerView * optionHeight + 0.5}rem;` : ""}
`);
const SelectWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
`;
const Wrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const Field = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div((props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  return `
  padding-left: ${(_a = props.theme) == null ? void 0 : _a.spacing.s12};
  padding-right: ${(_b = props.theme) == null ? void 0 : _b.spacing.s12};
  background: ${(_c = props.theme) == null ? void 0 : _c.colors.white};
  height: 2.5rem;
  border-radius: ${(_d = props.theme) == null ? void 0 : _d.spacing.s4};
  display: flex;
  align-items: center;
  border: ${(_e = props.theme) == null ? void 0 : _e.borderWeight.m} solid ${(_f = props.theme) == null ? void 0 : _f.colors.divider};
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  ${props.disabled ? `
    cursor: not-allowed;
    background: ${(_g = props.theme) == null ? void 0 : _g.colors.background};
  ` : ""}
  ${!props.active ? `&:hover {
    border: ${(_h = props.theme) == null ? void 0 : _h.borderWeight.m} solid ${(_i = props.theme) == null ? void 0 : _i.colors.placeholder};` : ""}
  }
  ${props.active ? `
    border: ${(_j = props.theme) == null ? void 0 : _j.borderWeight.m} solid ${props.activeColor || ((_k = props.theme) == null ? void 0 : _k.colors.link500)};
  ` : ""}
`;
});
const RightOutlinedWrapper = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ transform }) => `
    position: relative;
    right: -0.25rem;
    transition: 0.2s;
    ${transform ? `
    transform: rotate(90deg);
    ` : ""}
`);
const findOptionByValue = (options, value) => {
  return options.find((option) => option.value === value);
};
const Select = (_a) => {
  var _b = _a, {
    value,
    title,
    options = [],
    maxPerView,
    disabled = false,
    hasDivider = false,
    activeColor,
    selectValue,
    className
  } = _b, rest = __objRest(_b, [
    "value",
    "title",
    "options",
    "maxPerView",
    "disabled",
    "hasDivider",
    "activeColor",
    "selectValue",
    "className"
  ]);
  const optionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const selectRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [activeOption, setActiveOption] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)();
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setActiveOption(findOptionByValue(options, value));
  }, [value]);
  const onClickItem = (option) => {
    selectValue(option.value);
    setShow(false);
  };
  const toggle = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(() => {
    setShow(false);
  }, []);
  (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__/* .useClickOutside */ .O8)([selectRef, optionRef], toggle);
  if (!options.length)
    return null;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    className
  }, rest), title && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK, {
    level: 4,
    line: 1,
    marginBottom: "s4"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SelectWrapper, {
    ref: selectRef
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Field, {
    disabled,
    activeColor,
    onClick: (e) => {
      e.stopPropagation();
      if (!disabled)
        setShow(!show);
    },
    active: show
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LeftContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
    level: 1,
    line: 1
  }, (activeOption == null ? void 0 : activeOption.text) || (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_5__.t)("Ch\u1ECDn"))), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightOutlinedWrapper, {
    transform: show
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .RightOutlined */ .g, {
    color: "placeholder",
    size: 24
  })))), show && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ItemsWrapper, {
    ref: optionRef,
    maxPerView: (maxPerView != null ? maxPerView : Number.MAX_SAFE_INTEGER < options.length) ? maxPerView : void 0
  }, options.map((option, index) => {
    var _a2, _b2, _c, _d;
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Item, {
      key: index,
      onClick: () => onClickItem(option),
      hasDivider: index === options.length - 1 ? false : hasDivider
    }, option.icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_7__/* .Shape */ .b, {
      marginRight: "s12"
    }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(option.icon, {
      size: !((_b2 = (_a2 = option.icon) == null ? void 0 : _a2.props) == null ? void 0 : _b2.size) ? 24 : (_d = (_c = option.icon) == null ? void 0 : _c.props) == null ? void 0 : _d.size
    })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LeftContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .Body */ .uT, {
      level: 1,
      line: 1
    }, option.text)), value === option.value && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(RightContent, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CheckOutlined */ .b, {
      size: 24,
      color: activeColor || "primary500"
    })));
  }))));
};




/***/ }),

/***/ 320589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/lang/en.es.js
var enLang = {
	"Chọn": "Select"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/lang/vi.es.js
var viLang = {
	
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "ds-mobile";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), {
    ns: NAMESPACE,
    interpolation: { escapeValue: false }
  }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 650983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(479690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(855271);
/* harmony import */ var _SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46610);
/* harmony import */ var _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349055);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const getBackground = (props) => {
  if (props.link)
    return "transparent";
  if (props.outline)
    return props.theme.colors.white;
  return props.disabled ? `${props.theme.colors.gray400} !important` : props.variant === "primary" ? props.theme.brand.primary : props.variant === "secondary" ? props.theme.brand.secondary : props.variant === "tertiary" ? props.theme.brand.tertiary : props.variant === "normal" ? props.theme.colors.gray300 : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray400} !important` : props.theme.colors.gray200;
};
const getColor = (props) => {
  var _a, _b;
  if (props.variant === "tertiary")
    return props.theme.colors.text;
  if (props.tag && !props.outline && !props.link)
    return props.theme.colors.white + "!important";
  if (props.outline || props.link) {
    return props.variant === "primary" ? (_a = props.theme.brand) == null ? void 0 : _a.primary : props.variant === "secondary" ? (_b = props.theme.brand) == null ? void 0 : _b.secondary : props.variant === "danger" ? props.theme.colors.red : props.variant === "disabled" ? `${props.theme.colors.gray600} !important` : props.theme.colors.text;
  }
  if (props.disabled)
    return `${_configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray600 */ .r.colors.gray600} !important`;
  return props.variant && props.variant !== "normal" && !props.link ? _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.white */ .r.colors.white : _configs_theme_es_js__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors.gray900 */ .r.colors.gray900;
};
const StyledButton = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button */ .Z.button((props) => {
  return `
    cursor: pointer;
    border-radius: 4px;
    overflow: hidden;
    ${props.size === "lg" ? `
        line-height: 1.5;
        padding: .5rem 1rem;` : `
        line-height: 1rem;
        padding: .365rem .75rem;`}
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    background-color: ${getBackground(props)};
    border-color: ${props.outline ? getColor(props) : getBackground(props)};
    color: ${getColor(props)};
    border-width: 1px;
    border-style: solid;
    user-select: none;
    text-decoration: none;
    flex-direction: ${props.flexDirection};
    position: relative;
    ${props.block ? `width: 100%;` : ""}
    ${props.disabled && "pointer-events: none;"}
    &:focus {
      outline: 0;
    }
    `;
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Spacer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div`
  width: 0.4rem;
  height: 0.4rem;
`;
const LoadingWrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div */ .Z.div((props) => `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${getBackground(props)};
  .pulse {
    position: relative;
  left: -9999px;
  width: 4px;
  height: 4px;
  border-radius: 5px;
  background-color: ${getColor(props)};
  color: ${getColor(props)};
  box-shadow: 9999px 0 0 -5px ${getColor(props)};
  animation: dot-pulse 1.5s infinite linear;
  animation-delay: 0.25s;

  &:before,
  &:after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: ${getColor(props)};
    color: ${getColor(props)};
  }
  &:before {
    box-shadow: 9988px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }
  &:after {
    box-shadow: 10010px 0 0 -5px ${getColor(props)};
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }
  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9988px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9988px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 9999px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 9999px 0 0 -5px ${getColor(props)};
    }
  }

  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
    30% {
      box-shadow: 10010px 0 0 2px ${getColor(props)};
    }
    60%,
    100% {
      box-shadow: 10010px 0 0 -5px ${getColor(props)};
    }
  }
  }
`);
const StyledLink = StyledButton.withComponent("a");
const Button = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, {
    outline,
    variant,
    children,
    block,
    tag,
    icon,
    disabled,
    flexDirection = "row",
    loading,
    onClick
  } = _a, others = __objRest(_a, [
    "outline",
    "variant",
    "children",
    "block",
    "tag",
    "icon",
    "disabled",
    "flexDirection",
    "loading",
    "onClick"
  ]);
  const ButtonTag = tag === "a" ? StyledLink : StyledButton;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ButtonTag, __spreadValues({
    ref,
    block,
    variant,
    outline,
    flexDirection,
    disabled,
    tag,
    onClick: loading ? void 0 : onClick
  }, others), icon && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, __spreadValues({}, icon)), icon && children && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Spacer, {
    className: "spacer"
  }), children, loading && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(LoadingWrapper, {
    variant,
    outline
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "pulse"
  })));
});
Button.displayName = "Button";




/***/ }),

/***/ 923540:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ConfirmOver18YearOldModal": function() { return /* binding */ ConfirmOver18YearOldModal; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@emotion-styled-virtual-a36c90119c/0/cache/@emotion-styled-npm-11.3.0-a31c55914d-5e5c1e89d2.zip/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 1 modules
var emotion_styled_browser_esm = __webpack_require__(212951);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/Modal.es.js + 1 modules
var Modal_es = __webpack_require__(411213);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalHeader.es.js
var ModalHeader_es = __webpack_require__(891256);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalBody.es.js
var ModalBody_es = __webpack_require__(309110);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/components/NavBar/NavBar.es.js
var NavBar_es = __webpack_require__(598227);
// EXTERNAL MODULE: ../../packages/utils/dist/storage.es.js
var storage_es = __webpack_require__(653028);
// EXTERNAL MODULE: ./contexts/FeatureFlagProvider.tsx + 1 modules
var FeatureFlagProvider = __webpack_require__(723357);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./modules/profile/shared/UpdateProfileForm.tsx + 1 modules
var UpdateProfileForm = __webpack_require__(538854);
// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-254a7c064d/0/cache/next-npm-12.3.1-f509d21386-ac78592379.zip/node_modules/next/router.js
var next_router = __webpack_require__(35304);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-5fadb32b2b/1/packages/ui/dist/components/atoms/Button/Button.es.js
var Button_es = __webpack_require__(650983);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Modal/ModalFooter.es.js
var ModalFooter_es = __webpack_require__(651337);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Input/Input.es.js
var Input_es = __webpack_require__(725643);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-mobile-virtual-190eca22c0/1/packages/ds-mobile/dist/components/Select/Select.es.js
var Select_es = __webpack_require__(391122);
// EXTERNAL MODULE: ../../packages/utils/dist/number.es.js
var number_es = __webpack_require__(927250);
// EXTERNAL MODULE: ../../packages/types/dist/ds/index.es.js + 3 modules
var ds_index_es = __webpack_require__(285212);
;// CONCATENATED MODULE: ./modules/product-detail/shared/CheckAgeModalContent.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  max-width: 90%;\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  padding: 0 1rem;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  column-gap: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _taggedTemplateLiteral([
        "\n  justify-content: end;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _taggedTemplateLiteral([
        "\n  font-weight: 500;\n  font-size: 13px;\n  margin-bottom: 4px;\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    const data = _taggedTemplateLiteral([
        "\n  margin-bottom: 0.5rem;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}








const StyledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)(_templateObject(), (param)=>{
    let { isMobile  } = param;
    return isMobile ? "\n    .teko-modal-content {\n      padding: 0.25rem;\n    }" : "";
});
const StyledModalBody = (0,emotion_styled_browser_esm["default"])(ModalBody_es/* ModalBody */.f)(_templateObject1());
const StyledModalFooter = (0,emotion_styled_browser_esm["default"])(ModalFooter_es/* ModalFooter */.m)(_templateObject2());
const StyledModalFooterDesktop = (0,emotion_styled_browser_esm["default"])(StyledModalFooter)(_templateObject3());
const CancelButton = (0,emotion_styled_browser_esm["default"])(Button_es/* Button */.z)((param)=>{
    let { theme  } = param;
    return "\n  border: 0.5px solid ".concat(theme === null || theme === void 0 ? void 0 : theme.brand.primary, ";\n  background: #fff;\n  color: ").concat(theme === null || theme === void 0 ? void 0 : theme.brand.primary, ";\n");
});
const StyledTitle = emotion_styled_browser_esm["default"].div(_templateObject4());
const FormItemWrapper = emotion_styled_browser_esm["default"].div(_templateObject5());
const getCheckYearOptions = ()=>{
    const options = [];
    let startYear = new Date().getFullYear() - 18;
    for(let i = 0; i < 60; i++){
        const year = startYear--;
        options.push({
            text: "".concat(year),
            value: year
        });
    }
    return options;
};
const CheckAgeModalContent = (param)=>{
    let { show , onCancel , onOk , okText =(0,i18n.t)("X\xe1c nhận") , isMobile ,  } = param;
    const { 0: name , 1: setName  } = (0,react.useState)("");
    const { 0: year , 1: setYear  } = (0,react.useState)();
    const onSelectYear = (value)=>{
        // UX4BUYER-4531
        // make sure the passed value is number
        const year = typeof value === "number" ? value : (0,number_es/* stringToInteger */.C)(value, 0);
        setYear(year);
    };
    const buttonStyle = isMobile ? {
        width: "50%",
        display: "inline-block"
    } : {
        minWidth: "100px",
        display: "inline-block",
        height: "36px"
    };
    const Footer = isMobile ? StyledModalFooter : StyledModalFooterDesktop;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModal, {
        isMobile: isMobile,
        visible: show,
        size: isMobile ? ds_index_es/* SizeEnum.m */.mO.m : ds_index_es/* SizeEnum.s */.mO.s,
        showCloseIcon: false,
        footer: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader_es/* ModalHeader */.x, {
                children: [
                    (0,i18n.t)("X\xe1c nhận"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                        color: "textSecondary",
                        weight: "regular",
                        children: (0,i18n.t)("sites.shop-front.components.mobile.templates.ProductDetailTemplate.1")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledModalBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormItemWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitle, {
                                children: [
                                    (0,i18n.t)("Họ t\xean"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                        color: "textSecondary",
                                        weight: "regular",
                                        children: "(".concat((0,i18n.t)("bắt buộc"), ")")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input_es/* Input */.I, {
                                type: "text",
                                placeholder: (0,i18n.t)("Vui l\xf2ng nhập họ t\xean"),
                                value: name,
                                onChange: (value)=>setName(value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormItemWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select_es/* Select */.P, {
                            title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTitle, {
                                children: [
                                    (0,i18n.t)("Năm sinh"),
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                                        color: "textSecondary",
                                        weight: "regular",
                                        children: "(".concat((0,i18n.t)("bắt buộc"), ")")
                                    })
                                ]
                            }),
                            options: getCheckYearOptions(),
                            value: year,
                            selectValue: onSelectYear,
                            maxPerView: 8
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CancelButton, {
                        padding: [
                            "s0",
                            "s20"
                        ],
                        style: buttonStyle,
                        onClick: onCancel,
                        children: (0,i18n.t)("T\xf4i dưới 18 tuổi")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_es/* Button */.z, {
                        marginLeft: "s16",
                        padding: [
                            "s0",
                            "s20"
                        ],
                        style: buttonStyle,
                        variant: "primary",
                        onClick: onOk,
                        disabled: !(name === null || name === void 0 ? void 0 : name.trim()) || !year,
                        children: okText
                    })
                ]
            })
        ]
    });
};
const CheckAgeModalMobile = (param)=>{
    let { show , onCancel , onOk ,  } = param;
    return /*#__PURE__*/ _jsx(CheckAgeModalContent, {
        show: show,
        isMobile: true,
        onOk: onOk,
        onCancel: onCancel
    });
};
const CheckAgeModalDesktop = (param)=>{
    let { show , onCancel , onOk ,  } = param;
    return /*#__PURE__*/ _jsx(CheckAgeModalContent, {
        show: show,
        isMobile: false,
        onOk: onOk,
        onCancel: onCancel
    });
};

;// CONCATENATED MODULE: ./modules/product-detail/shared/ConfirmOver18YearOldModal.tsx
function ConfirmOver18YearOldModal_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ConfirmOver18YearOldModal_templateObject() {
    const data = ConfirmOver18YearOldModal_taggedTemplateLiteral([
        "\n  text-align: left;\n  padding-bottom: 0.5rem;\n"
    ]);
    ConfirmOver18YearOldModal_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ConfirmOver18YearOldModal_templateObject1() {
    const data = ConfirmOver18YearOldModal_taggedTemplateLiteral([
        "\n  max-height: 80vh;\n  overflow-y: auto;\n"
    ]);
    ConfirmOver18YearOldModal_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}













const ConfirmOver18YearOldModal = (param)=>{
    let { showPopupCheckAge , setShowPopupCheckAge , okText , onCancel  } = param;
    const { user  } = (0,context_es/* useAuth */.aC)();
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { flags  } = (0,FeatureFlagProvider/* useFeatureFlags */.g)();
    const handleCancel = ()=>{
        onCancel ? onCancel() : router_default().push("/");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: showPopupCheckAge && (flags.epic_ecom_315 && user ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UserRequireOver18Modal, {
            show: showPopupCheckAge,
            onCancel: handleCancel,
            onOk: ()=>{
                setShowPopupCheckAge(false);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckAgeModalContent, {
            isMobile: isMobile,
            show: showPopupCheckAge,
            onCancel: handleCancel,
            onOk: ()=>{
                (0,storage_es/* setCookieOver18YearOld */.zr)(true);
                setShowPopupCheckAge(false);
            },
            okText: okText
        }))
    });
};
const UserRequireOver18Modal = (param)=>{
    let { show , onCancel ,  } = param;
    const { 0: showUpdateInfoForm , 1: setShowUpdateInfoForm  } = (0,react.useState)(false);
    const router = (0,next_router.useRouter)();
    const { query  } = router;
    const { isMobile  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal_es/* Modal */.u, {
                showCloseIcon: false,
                visible: show,
                size: "s",
                cancelText: (0,i18n.t)("Quay lại"),
                onCancel: onCancel,
                okText: (0,i18n.t)("Cập nhật hồ sơ"),
                onOk: ()=>setShowUpdateInfoForm(true),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalHeader_es/* ModalHeader */.x, {
                    children: [
                        (0,i18n.t)("Th\xf4ng b\xe1o"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Body */.uT, {
                            weight: "regular",
                            marginTop: "s16",
                            children: (0,i18n.t)("Bạn phải \xedt nhất 18 tuổi để xem nội dung n\xe0y")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UpdateProfiledModal, {
                className: "update-profile-modal",
                visible: showUpdateInfoForm,
                onClose: ()=>setShowUpdateInfoForm(false),
                footer: false,
                showCloseIcon: false,
                isMobile: isMobile,
                children: [
                    !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalHeader, {
                        children: (0,i18n.t)("Th\xf4ng tin t\xe0i khoản")
                    }) : !query.hideHeader && !query.supportOmniAppUI ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar_es/* NavBar */.l, {
                        title: (0,i18n.t)("Th\xf4ng tin t\xe0i khoản"),
                        goBack: ()=>setShowUpdateInfoForm(false)
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmOver18YearOldModal_StyledModalBody, {
                        className: "modal-body",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateProfileForm/* UpdateProfileForm */.y, {
                            isMobile: isMobile,
                            transforms: {
                                uploadProfile: (defaultBehavior)=>{
                                    return async (profile)=>{
                                        const res = await defaultBehavior(profile);
                                        router.reload();
                                        return res;
                                    };
                                }
                            }
                        })
                    })
                ]
            })
        ]
    });
};
const UpdateProfiledModal = (0,emotion_styled_browser_esm["default"])(Modal_es/* Modal */.u)((param)=>{
    let { isMobile  } = param;
    return "\n  border-radius: 5px;\n  max-width: 32rem;\n  ".concat(isMobile ? "\n      .modal-body{\n        padding: 0.75rem;\n      }\n      .teko-modal-content {\n        height: 100vh;\n        max-height: 900px;\n        border-radius: 0;\n        padding: 0;\n      }\n        " : "", "\n");
});
const StyledModalHeader = (0,emotion_styled_browser_esm["default"])(ModalHeader_es/* ModalHeader */.x)(ConfirmOver18YearOldModal_templateObject());
const ConfirmOver18YearOldModal_StyledModalBody = (0,emotion_styled_browser_esm["default"])(ModalBody_es/* ModalBody */.f)(ConfirmOver18YearOldModal_templateObject1());


/***/ }),

/***/ 538854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "y": function() { return /* binding */ UpdateProfileForm; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(561261);
// EXTERNAL MODULE: ./i18n.ts
var i18n = __webpack_require__(634655);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(684443);
// EXTERNAL MODULE: ./contexts/ServiceContext.tsx
var ServiceContext = __webpack_require__(643015);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-user-virtual-6decbe5f8c/1/packages/ui-user/dist/hooks/useProfile.es.js
var useProfile_es = __webpack_require__(293152);
// EXTERNAL MODULE: ./modules/profile/hooks/useUploadProfile.ts
var useUploadProfile = __webpack_require__(573756);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-auth-react-virtual-5229284054/1/packages/auth-react/dist/context.es.js + 1 modules
var context_es = __webpack_require__(983546);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Shape/index.es.js
var index_es = __webpack_require__(425336);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/Typography/index.es.js + 1 modules
var Typography_index_es = __webpack_require__(621655);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(891987);
// EXTERNAL MODULE: ./modules/profile/shared/helpers.tsx
var helpers = __webpack_require__(520913);
// EXTERNAL MODULE: ./modules/profile/shared/GeneralFormikForm.tsx
var GeneralFormikForm = __webpack_require__(531356);
// EXTERNAL MODULE: ./modules/profile/shared/OtpConfirmationPopup.tsx
var OtpConfirmationPopup = __webpack_require__(972376);
// EXTERNAL MODULE: ../../packages/log/dist/index.es.js + 1 modules
var dist_index_es = __webpack_require__(420577);
// EXTERNAL MODULE: ./types/policy.ts
var types_policy = __webpack_require__(59181);
// EXTERNAL MODULE: ./components/PrivacyPolicies.tsx
var PrivacyPolicies = __webpack_require__(644525);
// EXTERNAL MODULE: ./helpers/index.ts
var helpers_0 = __webpack_require__(788813);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ds-foundation-virtual-dc53b6832e/1/packages/ds-foundation/dist/components/CustomLink/CustomLink.es.js
var CustomLink_es = __webpack_require__(618428);
;// CONCATENATED MODULE: ./modules/profile/shared/AdditionalButtons.tsx



const AdditionalButtons = (props)=>{
    const { additionalButtons  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
        children: additionalButtons.map((param, index)=>/*#__PURE__*/ {
            let { href , title , show , onClick  } = param;
            return (0,jsx_runtime.jsx)("div", {
                children: show && (href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink_es/* CustomLink */.x, {
                    href: href,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                        color: "link",
                        level: 1,
                        margin: [
                            "s12",
                            "s0"
                        ],
                        children: title
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Body */.uT, {
                    color: "link",
                    level: 1,
                    margin: [
                        "s12",
                        "s0"
                    ],
                    onClick: onClick,
                    style: {
                        cursor: "pointer"
                    },
                    children: title
                }))
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./modules/profile/shared/UpdateProfileForm.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}

















const PrivacyPolicyHeader = "Ch\xednh s\xe1ch quyền ri\xeang tư";
const UpdateProfileForm = (props)=>{
    const { isMobile =false , customRequireFields ={} , transforms , additionalButtons ,  } = props;
    const { notEditCustomerType , partner , supportedPhone , displayPrivacyPoliciesInProfileForm ,  } = (0,GlobalDataContext/* useTenantConfig */.Wx)();
    const { authService , userService , privacyPolicyService  } = (0,ServiceContext/* useServices */.Su)();
    const { setUser , user: profile , updateProfile  } = (0,context_es/* useAuth */.aC)();
    const { customerTypes  } = (0,useProfile_es/* useProfile */.U)({
        userService
    });
    const { 0: valuesForOTP , 1: setValuesForOTP  } = (0,react.useState)({});
    const { 0: policies , 1: setPolicies  } = (0,react.useState)([]);
    const { 0: originalPolicies , 1: setOriginalPolicies  } = (0,react.useState)([]);
    const defaultUploadProfile = async (profile)=>{
        return await (updateProfile === null || updateProfile === void 0 ? void 0 : updateProfile(profile));
    };
    const defaultVerifyPhone = async (telephone, OTP)=>{
        await authService.updatePhone(telephone, OTP);
        profile && (setUser === null || setUser === void 0 ? void 0 : setUser(_objectSpreadProps(_objectSpread({}, profile), {
            telephone: telephone
        })));
    };
    const transformedUpdateFunc = (0,helpers/* fallbackTransform */.Sj)(transforms === null || transforms === void 0 ? void 0 : transforms.uploadProfile, defaultUploadProfile);
    const transformedVerifyPhoneFunc = (0,helpers/* fallbackTransform */.Sj)(transforms === null || transforms === void 0 ? void 0 : transforms.verifyPhone, defaultVerifyPhone);
    const { waitingVerifyOTP , loading , otpError , otpData , requiredFields , allowEdit , message , feedbacks , countdown , resetStates , resendOTP , validate , update , verifyOtp ,  } = (0,useUploadProfile/* useUploadProfile */.f)({
        customRequireFields,
        uploadProfile: transformedUpdateFunc,
        verifyPhone: transformedVerifyPhoneFunc
    });
    (0,react.useEffect)(()=>{
        (async ()=>{
            try {
                const privacyPolicies = await privacyPolicyService.getPolicies([
                    "all_policies", 
                ]);
                setPolicies(privacyPolicies);
                setOriginalPolicies(privacyPolicies);
            } catch (error) {
                dist_index_es/* logger.error */.k.error(error);
            }
        })();
    }, []);
    const submit = async (values)=>{
        const { name , email , dob , sex , customerTypeId  } = values;
        update({
            name,
            email,
            dob,
            sex,
            customerTypeId
        });
        // submit privacy policy
        try {
            const submitPolicies = policies.filter((policy)=>policy.policyTypeId !== types_policy/* PolicyTypeId.TYPE_1 */.Y.TYPE_1).map((param)=>{
                let { id , version , language , isApproved  } = param;
                return {
                    id,
                    version,
                    language,
                    isApproved: isApproved || false
                };
            });
            await privacyPolicyService.submitPolicies(submitPolicies);
            setOriginalPolicies(policies);
        } catch (error) {
            dist_index_es/* logger.error */.k.error(error);
        }
        return undefined;
    };
    const comparePolicies = (0,react.useMemo)(()=>{
        if (originalPolicies.length !== policies.length) return false;
        for(let i = 0; i < policies.length; i++){
            var ref;
            if (policies[i].isApproved !== ((ref = originalPolicies.find((p)=>p.id === policies[i].id)) === null || ref === void 0 ? void 0 : ref.isApproved)) return false;
        }
        return true;
    }, [
        originalPolicies,
        policies
    ]);
    const getInputFields = (values, setFieldValue)=>(0,helpers/* getProfileInputFields */.qE)(values, setFieldValue, profile, partner, customerTypes, notEditCustomerType, allowEdit);
    const getButtonsProps = (values, _errors, dirty)=>{
        return [
            !!values.telephone && values.telephone !== (profile === null || profile === void 0 ? void 0 : profile.telephone) ? {
                type: "button",
                width: isMobile ? "100%" : "",
                onClick: ()=>{
                    const payload = {
                        telephone: values.telephone
                    };
                    update(payload);
                    setValuesForOTP(payload);
                },
                variant: "primary",
                disabled: !!feedbacks.telephone || loading || waitingVerifyOTP,
                children: (0,i18n.t)("X\xe1c nhận số điện thoại")
            } : {
                type: "submit",
                width: isMobile ? "100%" : "",
                variant: "primary",
                disabled: comparePolicies && !dirty || loading,
                children: (0,i18n.t)("Cập nhật")
            }, 
        ];
    };
    const initialValues = {
        name: profile === null || profile === void 0 ? void 0 : profile.name,
        telephone: profile === null || profile === void 0 ? void 0 : profile.telephone,
        email: profile === null || profile === void 0 ? void 0 : profile.email,
        sex: profile === null || profile === void 0 ? void 0 : profile.sex,
        dob: profile === null || profile === void 0 ? void 0 : profile.dob,
        customerTypeId: (profile === null || profile === void 0 ? void 0 : profile.customerTypeId) || undefined
    };
    const renderPolicies = policies.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                style: {
                    backgroundColor: "#F6F6F6",
                    marginLeft: "-32px",
                    marginRight: "-32px",
                    padding: "16px 0 6px 0"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                    style: {
                        paddingLeft: 16
                    },
                    textTransform: "uppercase",
                    color: "textSecondary",
                    children: (0,i18n.t)(PrivacyPolicyHeader)
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* Title */.Dx, {
                    paddingTop: "s40",
                    paddingBottom: "s16",
                    children: (0,i18n.t)(PrivacyPolicyHeader)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* Shape */.b, {
                paddingTop: "s16",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicies/* PrivacyPolicies */.v, {
                    policies: policies,
                    setPolicies: setPolicies,
                    trackingScreenName: "profile",
                    hideWarning: true,
                    disableChangeApproval: true,
                    isLoggedIn: (0,helpers_0/* isServerless */.ep)() && authService.isLoggedIn(),
                    originalPolicies: originalPolicies
                })
            })
        ]
    }) : null;
    const renderAdditionalButtons = !!additionalButtons && additionalButtons.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalButtons, {
        additionalButtons: additionalButtons
    }) : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !allowEdit && !!supportedPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography_index_es/* SubTitle */.DK, {
                color: "textSecondary",
                style: {
                    fontStyle: "italic"
                },
                marginBottom: "s16",
                children: (0,i18n.t)("Để thay đổi c\xe1c th\xf4ng tin đ\xe3 cung cấp, vui l\xf2ng li\xean hệ bộ phận CSKH của ch\xfang t\xf4i tại {{userPhone}}", {
                    userPhone: supportedPhone
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GeneralFormikForm/* GeneralFormikForm */.R, {
                isMobile: isMobile,
                submit: submit,
                validate: validate,
                feedbacks: feedbacks,
                messages: [
                    message
                ],
                initialFormValues: initialValues,
                requiredFields: requiredFields,
                getInputFields: getInputFields,
                getButtonsProps: getButtonsProps,
                policies: displayPrivacyPoliciesInProfileForm ? renderPolicies : null,
                additionalButtons: renderAdditionalButtons
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpConfirmationPopup/* OtpConfirmationPopup */.n, {
                isMobile: isMobile,
                values: valuesForOTP,
                waitingVerifyOTP: waitingVerifyOTP,
                otpError: otpError,
                otpData: otpData,
                countdown: countdown,
                resetStates: resetStates,
                resendOTP: resendOTP,
                verifyOtp: verifyOtp
            })
        ]
    });
};


/***/ })

}]);